module.exports = __webpack_public_path__ + "img/image17.b159cf46.jpg";